module.exports = __webpack_public_path__ + "images/landing/video-previews/whiteboard_2x.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/video-previews/whiteboard_2x.jpg
// module id = PqOi
// module chunks = 1